/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MailMagazineManagementListMailMagazineRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: MailMagazineManagementListMailMagazineRequest.direction | null;
    types?: string | null;
    userId?: string | null;
};

export namespace MailMagazineManagementListMailMagazineRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

